import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import Home from "./Pages/Home";
import Courses from "./Pages/Courses";
import CourseDetail from "./Pages/CourseDetail";
import Contact from "./Pages/Contact";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Services from './Pages/Services';
import About from './Pages/About';
import Login from './Pages/Login';
import Register from './Pages/Register';
import { AuthProvider } from './context/AuthContext';
import Profile from './Pages/Profile';
import AdminPanel from './Pages/admin/AdminPanel';
import Gallery from './Pages/Gallery';
import UserDatabase from './Pages/admin/UserDatabase';
import AcceptInvitation from './Pages/AcceptInvitation';
import TakeExam from './Pages/TakeExam';
import VerifyCertificate from './Pages/VerifyCertificate'; // 👈 renamed

import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = "757090728103-369a0lesaco2g3ovamhcppdl0r6ca35a.apps.googleusercontent.com";

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.remove(
      'home-page',
      'courses-page',
      'contact-page',
      'auth-page',
      'admin-page'
    );

    if (location.pathname === '/') {
      document.body.classList.add('home-page');
    } else if (location.pathname === '/courses' || location.pathname.startsWith('/courses/')) {
      document.body.classList.add('courses-page');
    } else if (location.pathname === '/contact') {
      document.body.classList.add('contact-page');
    } else if (location.pathname === '/login' || location.pathname === '/register') {
      document.body.classList.add('auth-page');
    } else if (location.pathname.startsWith('/admin')) {
      document.body.classList.add('admin-page');
    }
  }, [location]);

  // 👇 Route classification
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isExamRoute = location.pathname.startsWith('/exam/');
  const isVerifyRoute = location.pathname.startsWith('/verify/'); // 👈 NEW

  // 👇 Hide chrome on verify page too (it's a standalone public page)
  const hideNavbar = isAdminRoute || isExamRoute || isVerifyRoute;
  const hideFooter =
    isAdminRoute ||
    isExamRoute ||
    isVerifyRoute ||
    location.pathname === '/' ||
    location.pathname === '/profile';

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/gallery" element={<Gallery />} />

        {/* Exam & Invitation */}
        <Route path="/exam/accept-invite" element={<AcceptInvitation />} />
        <Route path="/exam/:id" element={<TakeExam />} />

        {/* Certificate Verification (public) */}
        <Route path="/verify/:token" element={<VerifyCertificate />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/users" element={<UserDatabase />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>

      {!hideFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <Router>
            <div className="App">
              <AppContent />
            </div>
          </Router>
        </AuthProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
}

export default App;